/* Fills any [data-rwc] element with the LIVE reward config from the backend, so customer-facing
   reward numbers never drift when the owner tunes rates/bonuses in Rewards Manager.
   The element's existing text is the fallback (shown if the fetch fails or the key is unknown).
   Keys: earn | member_earn | multiplier | redeem | tier:<dollars> | bonus:<name>  */
(function () {
  function fmt(n) { try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); } }
  function val(cfg, key) {
    if (!cfg) return null;
    if (key === 'earn') return cfg.earn_rate;
    if (key === 'member_earn') return (cfg.member_earn_rate != null ? cfg.member_earn_rate : (cfg.earn_rate * cfg.member_multiplier));
    if (key === 'multiplier') return cfg.member_multiplier;
    if (key === 'redeem') return cfg.redeem_rate;
    if (key.indexOf('tier:') === 0) {
      var d = parseInt(key.slice(5), 10);
      var t = (cfg.redeem_tiers || []).filter(function (x) { return x.dollars === d; })[0];
      return t ? t.flamingos : null;
    }
    if (key.indexOf('bonus:') === 0) { var b = cfg.bonus || {}; return b[key.slice(6)]; }
    return null;
  }
  function apply(cfg) {
    var els = document.querySelectorAll('[data-rwc]');
    for (var i = 0; i < els.length; i++) {
      var v = val(cfg, els[i].getAttribute('data-rwc'));
      if (v != null && !isNaN(v)) els[i].textContent = fmt(v);
    }
  }
  var cache = null;
  function load() {
    if (cache) { apply(cache); return; }
    fetch('/apps/soflo-delivery/rewards/config').then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.ok) { cache = j; apply(j); }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  // sections that render their markup via JS can re-trigger the fill
  document.addEventListener('sf:rewardconfig', load);
})();
